export default __webpack_public_path__ + "static/media/ppi-map-icon.ff7d3fb0.png";